import { render, staticRenderFns } from "./YzSwitch.vue?vue&type=template&id=b71bd442&scoped=true&lang=pug&"
import script from "./YzSwitch.vue?vue&type=script&lang=js&"
export * from "./YzSwitch.vue?vue&type=script&lang=js&"
import style0 from "./YzSwitch.vue?vue&type=style&index=0&id=b71bd442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71bd442",
  null
  
)

export default component.exports